module.exports = __webpack_public_path__ + "media/images/riders/DAKOTAH_NORTON-0ad2b4505ce96b2a72e5d8a4ad3e70f3.png";